import vietnameseFlag from '@assets/icon/vietnam.png';
import ukFlag from '@assets/icon/united-kingdom.png';

import i18n from './i18n';

export interface Language {
  language: () => string;
  flag: string;
  code: string;
  short: string;
}

export enum LANGUAGE_CODE {
  ENGLISH = 'en',
  VIETNAMESE = 'vi',
}

export const LANGUAGES: Language[] = [
  {
    language: () => i18n.t('common.vietnamese'),
    flag: vietnameseFlag,
    code: LANGUAGE_CODE.VIETNAMESE,
    short: 'VI',
  },
  {
    language: () => i18n.t('common.english'),
    flag: ukFlag,
    code: LANGUAGE_CODE.ENGLISH,
    short: 'EN',
  }
];
